import React from "react";
import { buildUrl, goTo } from "./utils";
import { useHotel } from "@/hooks/useHotel";
import { useTranslation } from "react-i18next";
import { BillingCard } from "./components/BillingCard";
import { StripeAction } from "./components/StripeAction";
import { BillingPageState } from "./components/BillingPageState";
import { useRefreshStripeConnect } from "./hooks/billing-settings.hooks";
import { useAccessCapabilities } from "@/hooks/useAccessCapabilities";
import { BillingSettingsNavigation } from "./components/BillingSettingsNavigation";

export const BillingSettingsRefreshPage = (): React.JSX.Element => {
  const { hotelId } = useHotel();
  const { t } = useTranslation();
  const { capabilities } = useAccessCapabilities();
  const canManageBilling = capabilities.canManageBilling;

  const refreshStripe = useRefreshStripeConnect();

  if (!hotelId) {
    return <BillingPageState text={t("billing.hotelNotSelected")} />;
  }

  if (!canManageBilling) {
    return (
      <BillingPageState
        text={t("common.insufficientPermissions", "Insufficient permissions.")}
        tone="error"
      />
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-[1344px] flex-col gap-6 p-6 md:p-8">
      <BillingSettingsNavigation activeTab="settings" />
      <BillingCard>
        <h1 className="text-base font-semibold text-black/96">
          {t("billing.connectStripeTitle")}
        </h1>
        <p className="text-sm text-black/65">{t("billing.refreshStripe")}</p>
        <StripeAction
          show={true}
          loading={refreshStripe.isPending}
          disabled={!canManageBilling || refreshStripe.isPending}
          onClick={() => {
            if (!canManageBilling) {
              return;
            }

            refreshStripe.mutate(
              {
                refreshUrl: buildUrl("/billing-settings/refresh"),
                returnUrl: buildUrl("/billing-settings"),
              },
              {
                onSuccess: (res: any) => goTo(res.onboardingUrl),
              },
            );
          }}
        />
      </BillingCard>
    </div>
  );
};
